const state = {
  change: false,
};

export const dashboard = {
  namespaced: true,
  state,
};
